import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var payMentRoute = [{
  path: "payMent/:orderId",
  name: "payMent",
  component: function component() {
    return import( /* webpackChunkName: "cart-list" */"./pay-ment.vue");
  }
}];